// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/SuperArticles/index.css
// module id = 3047
// module chunks = 0